import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyOverview from "./sections/PrivacyOverview";
import DataCollectionDetails from "./sections/DataCollectionDetails";
import UserRightsControls from "./sections/UserRightsControls";
import CookiesAndTrackingTechnologies from "./sections/CookiesAndTrackingTechnologies";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyOverview />
      <DataCollectionDetails />
      <UserRightsControls />
      <CookiesAndTrackingTechnologies />
      <Footer />
    </div>;
}